import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import DriverServiceMigrationApi from "../../services/api/DriverServiceMigration";

const handleError = (err) => {
  console.log("[DriverServiceMigration] Error in fetching upload url", err);
};

export const getZomatoToBlinkitMigrationUploadUrl =
  (payload) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response =
        await DriverServiceMigrationApi.getZomatoToBlinkitUploadUrl(payload);
      dispatch(setLoader(false));
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getBlinkitToZomatoMigrationUploadUrl =
  (payload) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let response =
        await DriverServiceMigrationApi.getBlinkitToZomatoUploadUrl(payload);
      dispatch(setLoader(false));
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };
